import { Condition, ConditionComparison, ValueSource, } from '../../models/Condition';
import { OutputViewModel } from '../../models/viewModels/OutputViewModel';
import { SmartSalesConstants } from '../SmartSalesConstants';
const USER_RESPONSE_VARIABLE_NAME = 'smartSalesUserResponse';
export const smartSalesConditionOutputs = [
    new OutputViewModel({
        $isSmartSalesOutput: true,
        $invalid: true,
        stateId: '',
        conditions: [
            new Condition({
                source: ValueSource.Context,
                comparison: ConditionComparison.Equals,
                variable: USER_RESPONSE_VARIABLE_NAME,
                values: [
                    SmartSalesConstants.USER_RESPONSE_STATUS.ACCEPT_TO_BUY,
                ],
            }),
        ],
    }),
    new OutputViewModel({
        $isSmartSalesOutput: true,
        $invalid: true,
        stateId: '',
        conditions: [
            new Condition({
                source: ValueSource.Context,
                comparison: ConditionComparison.Equals,
                variable: USER_RESPONSE_VARIABLE_NAME,
                values: [
                    SmartSalesConstants.USER_RESPONSE_STATUS.REFUSED_TO_BUY,
                ],
            }),
        ],
    }),
    new OutputViewModel({
        $isSmartSalesOutput: true,
        $invalid: true,
        stateId: '',
        conditions: [
            new Condition({
                source: ValueSource.Context,
                comparison: ConditionComparison.Equals,
                variable: USER_RESPONSE_VARIABLE_NAME,
                values: [SmartSalesConstants.USER_RESPONSE_STATUS.INACTIVITY],
            }),
        ],
    }),
];
